// @flow

/**
 * Module dependencies.
 */

import { get } from 'lodash';
import { legal } from 'client/markdown';
import LegalContent from 'client/components/legal-and-compliance/legal-content';
import React from 'react';
import i18n from 'client/translations/i18n';

/**
 * Get legal content.
 */

const getLegalContent = (key: string): string => get(legal, `${i18n.language}.${key}`, '');

/**
 * Export `legalPage` component.
 */

export const legalPage = (key: string) => () => <LegalContent source={getLegalContent(key)} />;



// WEBPACK FOOTER //
// ../src/client/containers/legal-and-compliance/index.js